<script>
	import Footer from "./Footer.svelte";
	import Part1 from "./Part1.svelte";
	import Part2 from "./Part2.svelte";
	import Part3 from "./Part3.svelte";

	let visiblePart1 = true;
	let visiblePart2 = false;
	let visiblePart3 = false;

	function togglePart(i) {
		switch (i) {
			case 1:
				visiblePart1 = true;
				visiblePart2 = false;
				visiblePart3 = false;
				break;
			case 2:
				visiblePart1 = false;
				visiblePart2 = true;
				visiblePart3 = false;
				break;
			case 3:
				visiblePart1 = false;
				visiblePart2 = false;
				visiblePart3 = true;
				break;
			default:
				break;
		}
	}
</script>

<main>
	<div class="header">
		<div class="btn-ctn">
			<button on:click={() => togglePart(1)}>
				<h2>Les grandes lignes</h2>
				<hr />
			</button>
			<button on:click={() => togglePart(2)}>
				<h2>Avantages / Inconvénients</h2>
				<hr />
			</button>
			<button on:click={() => togglePart(3)}>
				<h2>Exemple de fonctionnement</h2>
				<hr />
			</button>
		</div>
		<h1>React Native</h1>
	</div>
	<div class="content-ctn">
		{#if visiblePart1}
			<Part1 />
		{/if}
		{#if visiblePart2}
			<Part2 />
		{/if}
		{#if visiblePart3}
			<Part3 />
		{/if}
	</div>
	<Footer />
</main>

<style>
	main {
		text-align: center;
		padding: 0 1rem;
		margin: 0;
		overflow: hidden;
	}

	h1 {
		color: #61dafb;
		font-size: 7vh;
		font-weight: 500;
		margin: 0;
		text-align: center;
	}

	h2 {
		margin: 0;
		text-align: center;
		font-size: 1.4rem;
		font-weight: normal;
		font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
	}

	.header {
		height: 20vh;
		border-bottom: solid 1px black;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	hr {
		width: 0;
		border-color: transparent;
		position: absolute;
		bottom: 0;
		left: 0;
		height: 10;
		color: transparent;
		border-bottom: 2px solid;
		margin: 0;
		transition: all 1s cubic-bezier(0.22, 1, 0.36, 1);
	}

	button:hover > hr {
		width: calc(100% - 2px);
		border-bottom-color: #aaaaaa;
	}

	button {
		position: relative;
		width: calc(100% / 3);
		height: 100%;
		margin: 0;
		border-width: 0;
		border-left: 2px solid white;
		border-right: 2px solid white;
		background-color: #eeeeee;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.btn-ctn {
		width: 100%;
		height: 50%;
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.content-ctn {
		height: 70vh;
		position: relative;
	}
</style>
